export default function Win10Card({ title, children }) {
  return (
    <div className="bg-white border border-gray-300 shadow-sm p-4 rounded-sm">
      {title && (
        <h2 className="text-xl font-semibold text-blue-700 mb-3">{title}</h2>
      )}
      {children}
    </div>
  );
}
